// project imports
import { AuthHeader, ApiUrl } from 'utils/Constants';
import ConvertDate from 'utils/DateHelper';

// ===============================|| User ||=============================== //

export const SetUserData = async (user_data) => {
    AuthHeader.Authorization = 'Bearer ' + localStorage.getItem('token');

    // Get user data
    const res = await fetch(`${ApiUrl}/api/user/profile`, {
        headers: AuthHeader
    });
    const response = await res.json();
    const data = response.data;

    const oldUserData = UserData();

    const userData = {
        Id: data?.id,
        Name: data?.first_name + ' ' + data?.last_name,
        Image: data?.image ? (data?.image.indexOf('data:') < 0 ? ApiUrl + '/' : '') + data?.image : null,
        Bases: data?.bases?.map((basis) => basis.id),
        ExpireDate: data?.bases[0]?.expire_date,
        Coin: data?.coin,
        Diamond: data?.diamond,
        Level: data?.level,
        Rank: data?.rank,
        ToNewLevel: 25
    };
    localStorage.setItem('userData', JSON.stringify(userData));

    /*
    if (oldUserData?.Coin != userData?.Coin) {
        setTextByElementById('user-coin', userData.Coin.toLocaleString());
        setAnimationByElementById('user-coin-change', 'slideTopFade 900ms cubic-bezier(0.5, 0, 0.75, 0) 0s 1 reverse forwards');
    }
    if (oldUserData?.Diamond != userData?.Diamond) {
        setTextByElementById('user-diamond', userData.Diamond.toLocaleString());
        setAnimationByElementById('user-diamond-change', 'slideTopFade 900ms cubic-bezier(0.5, 0, 0.75, 0) 0s 1 reverse forwards');
    }
    */
    if (oldUserData?.ExpireDate != userData?.ExpireDate) {
        setTextByElementById('user-expire-date', ConvertDate(userData.ExpireDate, 'YYYY/MM/DD'));
        setAnimationByElementById('user-expire-date-change', 'slideTopFade 900ms cubic-bezier(0.5, 0, 0.75, 0) 0s 1 reverse forwards');
    }
    if (oldUserData?.Level != userData?.Level) {
        setTextByElementById('user-level', userData.Level.toLocaleString());
        setAnimationByElementById('user-level-change', 'slideTopFade 900ms cubic-bezier(0.5, 0, 0.75, 0) 0s 1 reverse forwards');
    }
    if (oldUserData?.Rank != userData?.Rank) {
        setTextByElementById('user-rank', userData.Rank.toLocaleString());
    }
};

export default SetUserData;

export const UserData = () => {
    return JSON.parse(localStorage.getItem('userData'));
};

export const Logout = () => {
    const lastToken = localStorage.getItem('lastToken');
    if (lastToken) {
        localStorage.setItem('token', lastToken);
        localStorage.removeItem('lastToken');
        localStorage.setItem(
            'userData',
            JSON.stringify({
                Id: 1,
                Name: 'Admin'
            })
        );
        location.href = '/';
    } else {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        AuthHeader.Authorization = '';
        location.href = '/';
    }
};

export const CheckAuth = async () => {
    try {
        const res = await fetch(`${ApiUrl}/api/user/profile`, {
            method: 'GET',
            headers: AuthHeader
        });
        const response = await res.json();
        return response.success;
    } catch (error) {
        return false;
    }
};

export const UserLabel = (user) => {
    return `${user?.first_name} ${user?.last_name}`;
};

const setTextByElementById = (id, text) => {
    if (document.getElementById(id)) {
        document.getElementById(id).innerText = text;
    }
    return false;
};

const setAnimationByElementById = (id, value) => {
    if (document.getElementById(id)) {
        document.getElementById(id).style.animation = value;
    }
    return false;
};
